

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseurl =
    process.env.REACT_APP_BASE_URL ||
    "http://localhost:8000/api";

const handleError = (error) => {
    const data = error?.response?.data;

    if (typeof data === "string") {
        return {
            detail: data,
        };
    }

    return data || { detail: error?.message || "Request failed." };
};

const getHeaders = (token) => ({
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

const getJsonHeaders = (token) => ({
    Accept: "application/json",
    "ngrok-skip-browser-warning": "true",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const getSubscriptionPlans = createAsyncThunk(
    "payments/getSubscriptionPlans",
    async (_, { rejectWithValue }) => {
        const url = `${baseurl}/payments/plans/`;

        try {
                        const response = await axios.get(url, {
                headers: {
                    "ngrok-skip-browser-warning": "true",
                },
            });
                        return response.data;
        } catch (error) {
                        return rejectWithValue(handleError(error));
        }
    }
);

export const createCheckoutSession = createAsyncThunk(
    "payments/createCheckoutSession",
    async ({ plan_id, success_url, cancel_url }, { rejectWithValue, getState }) => {
        try {
            const token = getState()?.auth?.access_token || localStorage.getItem("access_token");
            const url = `${baseurl}/payments/checkout/`;
            const payload = {
                plan_id,
                success_url,
                cancel_url,
            };

                        const response = await axios.post(
                url,
                payload,
                { headers: getHeaders(token) }
            );
                        return response.data;
        } catch (error) {
                        return rejectWithValue(handleError(error));
        }
    }
);

export const verifyPaymentSession = createAsyncThunk(
    "payments/verifyPaymentSession",
    async ({ session_id }, { rejectWithValue, getState }) => {
        const verifyUrl = `${baseurl}/payments/verify/`;

        if (!session_id) {
                        return rejectWithValue({ detail: "Stripe session_id is missing." });
        }

        try {
            const token = getState()?.auth?.access_token || localStorage.getItem("access_token");
                        const response = await axios.get(verifyUrl, {
                headers: getJsonHeaders(token),
                params: { session_id },
            });

            if (response.data?.success === false) {
                                return rejectWithValue(response.data);
            }

                        return response.data;
        } catch (error) {
            
            return rejectWithValue(handleError(error));
        }
    }
);

export const getSubscriptionStatus = createAsyncThunk(
    "payments/getSubscriptionStatus",
    async (_, { rejectWithValue, getState }) => {
        const url = `${baseurl}/payments/status/`;

        try {
            const token = getState()?.auth?.access_token || localStorage.getItem("access_token");
                        const response = await axios.get(url, {
                headers: getHeaders(token),
            });
                        return response.data;
        } catch (error) {
                        return rejectWithValue(handleError(error));
        }
    }
);
